import StructuredDataForm, {
  StructuredDataFormData,
} from '~/components/StructuredDataForm/StructuredDataForm'
import { JsonSchema } from '~/types/JsonSchema.interface'
import cs from './generate_test_data_form.scss'

export default function ManualDatasetUploadForm({
  className,
  manualUploadDataParams,
  setManualUploadDataParams,
}: {
  className?: string
  manualUploadDataParams: StructuredDataFormData
  setManualUploadDataParams: (values: StructuredDataFormData) => void
}) {
  // Static schema with a folder_path field type for enhanced UI with browse button
  const schema: JsonSchema = {
    properties: {
      directory_or_file_path: {
        title: 'Directory Path',
        type: 'folder_path',
        description:
          'Enter the path to the directory containing the dataset. For example, C:\\Users\\Image Archive\\2025\\2025-09\\2025-09-20\\2025-09-20T00-00-00',
        default: '',
      },
    },
  }

  const handleUpdate = (key: string, newValue: unknown) => {
    if (newValue === null) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [key]: _, ...paramsWithoutKey } = manualUploadDataParams ?? {}
      setManualUploadDataParams(paramsWithoutKey)
    } else {
      setManualUploadDataParams({ ...(manualUploadDataParams ?? {}), [key]: newValue })
    }
  }

  return (
    <div className={className}>
      <StructuredDataForm
        data={manualUploadDataParams}
        variant='wideValues'
        onEdit={handleUpdate}
        dataSchema={schema}
        className={cs.structuredDataForm}
      />
    </div>
  )
}
